import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, Renderer2, DOCUMENT } from '@angular/core'
import { AuthService } from '@app/modules/auth/auth.service'

import { DestroyService } from '@core/services/destroy.service'
import { User } from '@shared/models/user.model'
import { PlatformSettingsService } from '@core/services/platfrom-settings.service'
import { PlatformSettings } from '@shared/models/platform-settings.model'
import { filter, switchMap, takeUntil, tap } from 'rxjs/operators'
import { VehiclesService } from '@app/modules/client/vehicles/vehicles.service'

declare global {
  interface IntercomOptions {
    // https://developers.intercom.com/installing-intercom/docs/javascript-api-attributes-objects
    app_id: string
    email: string
    name: string
    created_at: string | number
    custom_launcher_selector: string
    company?: {
      company_id?: string | number
      name?: string
      plan?: string
      'Fleet Size'?: number
    }
  }

  type IntercomOptionsCallback = () => void

  interface Window {
    Intercom: (string, IntercomOptions?: Partial<IntercomOptions> | IntercomOptionsCallback) => void
  }
}

@Component({
  selector: 'lin-intercom',
  templateUrl: './intercom.component.html',
  styleUrls: ['./intercom.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class IntercomComponent implements OnInit, OnDestroy {
  isShow = false
  isEnabled = false

  private user: User
  private count: number
  private intercomId: string
  private readonly toggleIntercomId = '#toggleIntercom'

  constructor(
    private renderer2: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    private readonly authService: AuthService,
    private readonly destroyService: DestroyService,
    private readonly cdr: ChangeDetectorRef,
    private readonly platformSettingsService: PlatformSettingsService,
    private readonly vehicleService: VehiclesService,
  ) {}

  ngOnInit(): void {
    this.user = this.authService.getCurrentUser()

    this.vehicleService
      .getVehicleCount()
      .pipe(
        tap(({ count }) => (this.count = count)),
        switchMap(() => this.platformSettingsService.platformSettings$),
        filter<PlatformSettings>(Boolean),
        takeUntil(this.destroyService),
      )
      .subscribe((platformSettings: PlatformSettings) => {
        this.initScript()
        // this.isEnabled = !!platformSettings.intercomId
        // if (this.isEnabled) {
        //   this.intercomId = platformSettings.intercomId
        //   this.initScript()
        // }
      })
  }

  ngOnDestroy(): void {
    window.Intercom('shutdown')
  }

  handleToggleIntercom(): void {
    // window.Intercom('update')
    // this.isShow ? window.Intercom('hide') : window.Intercom('show')
    // this.isShow = !this.isShow

    if (this.isShow) {
      window.HubSpotConversations.widget.close()
    } else {
      window.HubSpotConversations.widget.open()
    }

    this.isShow = !this.isShow
    this.cdr.detectChanges()
  }

  private initScript(): void {
    /*const onload = (): void => {
      window.Intercom('boot', {
        // https://developers.intercom.com/installing-intercom/docs/javascript-api-attributes-objects
        app_id: this.intercomId,
        custom_launcher_selector: this.toggleIntercomId,
        name: this.user.name, // Full name
        email: this.user.email, // Email address
        created_at: this.user.createdAt, // Signup date as a Unix timestamp
        ...(this.user.isClient() && {
          company: {
            company_id: this.user.team.clientId,
            name: this.user.team.clientName,
            plan: this.user?.plan?.displayName,
            'Fleet Size': this.count,
          },
        }),
      })
      window.Intercom('update')
      this.subscribeIntercomHandles()
      this.cdr.detectChanges()
    }

    const script = this.renderer2.createElement('script') as HTMLScriptElement
    script.src = `https://widget.intercom.io/widget/${this.intercomId}`
    script.async = true
    script.onload = onload*/

    // const hubScript = this.renderer2.createElement('script') as HTMLScriptElement
    // hubScript.src = `https://js-na1.hs-scripts.com/5724608.js`
    // hubScript.async = true
    // hubScript.onload = onload

    // //this.renderer2.appendChild(this.document.body, script)
    // this.renderer2.appendChild(this.document.body, hubScript)

    const hubScript = this.renderer2.createElement('script') as HTMLScriptElement
    hubScript.src = 'https://js-na1.hs-scripts.com/5724608.js'
    hubScript.async = true

    hubScript.onload = () => {
      window.hsConversationsOnReady = () => {
        window.HubSpotConversations.widget.close()
      }
    }

    this.renderer2.appendChild(this.document.body, hubScript)
  }

  private subscribeIntercomHandles(): void {
    window.Intercom('onHide', () => {
      this.isShow = false
      this.cdr.detectChanges()
    })
  }
}
